/*
 Права на правку колонки инфо у позиций и действий склада. Инфо это элемент выборки, поэтому
 правка требует и полного доступа к складу, и права на изменение элементов выборки. Табличный
 комментарий сюда не входит, у него своё правило по доступу к аналитике.
*/

import { generalStore } from "@/store/general";
import { storageStore } from "@/store/storage/storage-instances";

export function canEditStorageDetails(): boolean {
  return (
    !!storageStore().storageAccess?.CanWrite &&
    !!generalStore().accessRights?.WriteAccess
  );
}
